import { ReleaseType } from 'types/releases';
import { LabelV2VersionAudioComponent } from '../LabelV2VersionAudio/LabelV2VersionAudioComponent';
import { SoundCloudVersionAudioComponent } from '../SoundCloudVersionAudio';
import { SoundCloudVersionAudioFormProps } from '../SoundCloudVersionAudio/types';
import { TuneCoreVersionAudioComponent } from '../TuneCoreVersionAudio';

interface VersionAudioComponentProps extends SoundCloudVersionAudioFormProps {
  type: ReleaseType;
}

export const VersionAudioComponent = ({
  type,
  ...props
}: VersionAudioComponentProps) => {
  if (type === ReleaseType.SOUNDCLOUD) {
    return <SoundCloudVersionAudioComponent {...props} />;
  }

  if (type === ReleaseType.TUNECORE) {
    return <TuneCoreVersionAudioComponent {...props} />;
  }

  return <LabelV2VersionAudioComponent {...props} />;
};
